"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rejectAfterTimeout = exports.resolveAfterTimeout = exports.createControllablePromise = void 0;
const createControllablePromise = () => {
    let resolve;
    let reject;
    const promise = new Promise((innerResolve, innerReject) => {
        resolve = innerResolve;
        reject = innerReject;
    });
    // INTENDED: for whatever reason TS doesn't realize that resolve and
    // reject are set on promise initialization
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return { promise, reject, resolve };
};
exports.createControllablePromise = createControllablePromise;
const resolveAfterTimeout = (value, time = 0) => new Promise((resolve) => setTimeout(() => resolve(value), time));
exports.resolveAfterTimeout = resolveAfterTimeout;
const rejectAfterTimeout = (value, time = 0) => new Promise((_, reject) => setTimeout(() => reject(value), time));
exports.rejectAfterTimeout = rejectAfterTimeout;
//# sourceMappingURL=promise_utils.js.map